import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Select/select';
import checkStyles from '@patternfly/react-styles/css/components/Check/check';
import { css } from '@patternfly/react-styles';
import CheckIcon from '@patternfly/react-icons/dist/js/icons/check-icon';
import { SelectConsumer, SelectVariant, KeyTypes } from './selectConstants';
export var SelectOption =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectOption, _React$Component);

  function SelectOption() {
    var _this;

    _classCallCheck(this, SelectOption);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectOption).apply(this, arguments));
    _this.ref = React.createRef();

    _this.onKeyDown = function (event) {
      if (event.key === KeyTypes.Tab) {
        return;
      }

      event.preventDefault();

      if (event.key === KeyTypes.ArrowUp) {
        _this.props.keyHandler(_this.props.index, 'up');
      } else if (event.key === KeyTypes.ArrowDown) {
        _this.props.keyHandler(_this.props.index, 'down');
      } else if (event.key === KeyTypes.Enter) {
        _this.ref.current.click();

        if (_this.context.variant === SelectVariant.checkbox) {
          _this.ref.current.focus();
        }
      }
    };

    return _this;
  }

  _createClass(SelectOption, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.sendRef(this.props.isDisabled ? null : this.ref.current, this.props.index);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.sendRef(this.props.isDisabled ? null : this.ref.current, this.props.index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /* eslint-disable @typescript-eslint/no-unused-vars */
      var _a = this.props,
          children = _a.children,
          className = _a.className,
          value = _a.value,
          _onClick = _a.onClick,
          isDisabled = _a.isDisabled,
          isPlaceholder = _a.isPlaceholder,
          isNoResultsOption = _a.isNoResultsOption,
          isSelected = _a.isSelected,
          isChecked = _a.isChecked,
          isFocused = _a.isFocused,
          sendRef = _a.sendRef,
          keyHandler = _a.keyHandler,
          index = _a.index,
          component = _a.component,
          props = __rest(_a, ["children", "className", "value", "onClick", "isDisabled", "isPlaceholder", "isNoResultsOption", "isSelected", "isChecked", "isFocused", "sendRef", "keyHandler", "index", "component"]);
      /* eslint-enable @typescript-eslint/no-unused-vars */


      var Component = component;
      return React.createElement(SelectConsumer, null, function (_ref) {
        var onSelect = _ref.onSelect,
            onClose = _ref.onClose,
            variant = _ref.variant;
        return React.createElement(React.Fragment, null, variant !== SelectVariant.checkbox && React.createElement("li", {
          role: "presentation"
        }, React.createElement(Component, Object.assign({}, props, {
          className: css(styles.selectMenuItem, isSelected && styles.modifiers.selected, isDisabled && styles.modifiers.disabled, isFocused && styles.modifiers.focus, className),
          onClick: function onClick(event) {
            if (!isDisabled) {
              _onClick(event);

              onSelect(event, value, isPlaceholder);
              onClose();
            }
          },
          role: "option",
          "aria-selected": isSelected || null,
          ref: _this2.ref,
          onKeyDown: _this2.onKeyDown,
          type: "button"
        }), children || value.toString(), isSelected && React.createElement("span", {
          className: css(styles.selectMenuItemIcon)
        }, React.createElement(CheckIcon, {
          "aria-hidden": true
        })))), variant === SelectVariant.checkbox && !isNoResultsOption && React.createElement("label", Object.assign({}, props, {
          className: css(checkStyles.check, styles.selectMenuItem, isDisabled && styles.modifiers.disabled, isFocused && styles.modifiers.focus, className),
          onKeyDown: _this2.onKeyDown
        }), React.createElement("input", {
          id: value.toString(),
          className: css(checkStyles.checkInput),
          type: "checkbox",
          onChange: function onChange(event) {
            if (!isDisabled) {
              _onClick(event);

              onSelect(event, value);
            }
          },
          ref: _this2.ref,
          checked: isChecked || false,
          disabled: isDisabled
        }), React.createElement("span", {
          className: css(checkStyles.checkLabel, isDisabled && styles.modifiers.disabled)
        }, children || value.toString())), variant === SelectVariant.checkbox && isNoResultsOption && React.createElement("div", null, React.createElement(Component, Object.assign({}, props, {
          className: css(styles.selectMenuItem, isSelected && styles.modifiers.selected, isDisabled && styles.modifiers.disabled, className),
          role: "option",
          "aria-selected": isSelected || null,
          ref: _this2.ref,
          onKeyDown: _this2.onKeyDown,
          type: "button"
        }), children || value.toString())));
      });
    }
  }]);

  return SelectOption;
}(React.Component);
SelectOption.defaultProps = {
  className: '',
  value: '',
  index: 0,
  isDisabled: false,
  isPlaceholder: false,
  isSelected: false,
  isChecked: false,
  isNoResultsOption: false,
  component: 'button',
  onClick: function onClick() {},
  sendRef: function sendRef() {},
  keyHandler: function keyHandler() {}
};